import { render, staticRenderFns } from "./SubscriptionCardComponent.vue?vue&type=template&id=019ffe33&scoped=true&"
import script from "./SubscriptionCardComponent.vue?vue&type=script&lang=js&"
export * from "./SubscriptionCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionCardComponent.vue?vue&type=style&index=0&id=019ffe33&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019ffe33",
  null
  
)

export default component.exports